import { all, call, put, select, takeEvery } from "redux-saga/effects"
import { browserHistory } from "react-router"
import { DckActionTypes, DckSelectors } from "dck-redux"
import store from "store"

import * as ItemTypes from "../../items/types"
import apiServerApi from "../apiServerApi"
import apiServerConstants from "../apiServerConstants"
import ProcessTypes from "../../processes/types"
import {
  addUniqueValue,
  convertToObject,
  fillingZeroUtility,
  formatCollateralName,
  formatCurrency,
  getFrequencyType,
  HTTP_VERB,
  parseFetchError
} from "../../../lib/utils"
import { makeSagaQuery } from "../utils"

export function manageBundleItem(item) {

  const { id, cost, currencyCode, purchaseCost, numberOfRepayments, repaymentEvery,
    repaymentFrequencyType, loanCollateral } = item

  item.photoUrl = `${apiServerConstants.host}/bundle/image/download/${id}`
  item.amountFormatted = `${ formatCurrency(cost) } ${currencyCode}`
  item.purchaseAmountFormatted = purchaseCost ? `${ formatCurrency(purchaseCost) } ${currencyCode}` : ''
  item.repayments = `${ fillingZeroUtility(numberOfRepayments) } every ${
    fillingZeroUtility(repaymentEvery)} ${ getFrequencyType(repaymentFrequencyType) }`
  item.collaterals = formatCollateralName(loanCollateral)

  return item
}

function* loadBundlesSaga() {

  const collateralNames = [],

  resp = yield makeSagaQuery(
    `${apiServerConstants.host}/bundle/listall`,
    HTTP_VERB.GET,
    null,
    ProcessTypes.LAOD_BUNDLES_PROCESS,
    true,
    response => {

      let bundles = response.body
      if (!(bundles instanceof Array)) return

      bundles = bundles.map(item => {

        item = manageBundleItem(item)

        addUniqueValue(collateralNames, item.collaterals)
  
        return item
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Bundle,
        data: bundles
      }
    }
  )

  if (resp) {
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.CollateralBundleFilter,
      data: [ convertToObject(collateralNames) ]
    })
  }
}

function* saveBundle(bundle) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.BUNDLE_SAVE
  })

  let processResult

  try {

    const state = store.get("sessionData")
    let file = bundle.data.file,
      newImageId

    if (file instanceof File) {
      newImageId = (yield call(
        apiServerApi.saveBundleImage,
        state.access_token,
        file,
        bundle.data.id
      )).body
    }

    delete bundle.data.file
    if(newImageId !== undefined && newImageId.length > 0) {
      bundle.data.imageId = newImageId
    }

    yield call(apiServerApi.saveBundle, state.access_token, bundle.data)
    processResult = { success: true, message: null }
  }
  catch(error) {
    processResult = { success: false, message: parseFetchError(error).text }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.BUNDLE_SAVE,
    result: processResult
  })

  if(processResult.success) {
    yield call(browserHistory.push, "/bundles")
  }
}

function* removeBundle(action) {

  try {

    const state = store.get("sessionData")
    yield call(apiServerApi.removeBundle, state.access_token, action.id)

    //  Dispatch an action to reload the bundle list
    yield put({
      type: DckActionTypes.ITEMS_LOAD,
      itemType: ItemTypes.Bundle,
    })
  }
  catch (e) {
    console.error(e)
  }
}

function *setBundle({ id, data }) {

  const bundles = yield select(state => DckSelectors.selectAllItems(state, ItemTypes.Bundle)),
  index = bundles.findIndex(elt => elt.id === id),
  fullData = manageBundleItem(data)

  if (index > -1) {
    bundles[index] = fullData
  }
  else {
    bundles.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Bundle,
    data: bundles
  })
}

function* bundlesSaga() {

  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Bundle,
      loadBundlesSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_ADD &&
        action.itemType === ItemTypes.Bundle,
      saveBundle
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SAVE &&
        action.itemType === ItemTypes.Bundle,
      saveBundle
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.Bundle,
      removeBundle
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.Bundle,
      setBundle
    ),
  ])
}

export default bundlesSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/bundles.js